module.exports = __webpack_public_path__ + "media/images/icn-play-36650ee7.png";